import script from "./AddProductFacilityGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProductFacilityGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddProductFacilityGroupModal.vue?vue&type=style&index=0&id=00ea317c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ea317c"]])

export default __exports__